import { SolutionColors } from "@smartsuite/react-ui";
import React, { useMemo, useState } from "react";
import { ImportUI } from "../../src";
import { DEFAULT_MEMBER } from "../../src/defaults/member";
import { buildDefaultSolution } from "../../src/defaults/solution";
import { ImportType } from "../../src/stores/config.store";
import type { SetupSettings } from "../SetupDropdown";
import { SetupDropdown } from "../SetupDropdown";

export const Demo = (): JSX.Element => {
  const [value, setValue] = useState<SetupSettings>({
    accountId:
      localStorage.getItem("accountId") ??
      process.env.REACT_APP_ACCOUNT_ID ??
      "",
    role: localStorage.getItem("role") ?? process.env.REACT_APP_ROLE ?? "",
    accessToken:
      localStorage.getItem("accessToken") ??
      process.env.REACT_APP_ACCESS_TOKEN ??
      "",
    applicationId:
      localStorage.getItem("applicationId") ??
      process.env.REACT_APP_APPLICATION_ID ??
      "",
    lang: localStorage.getItem("automationsUILang") ?? "en",
    logoColor: SolutionColors.basePrimaryBlue,
    importType:
      (localStorage.getItem("importType") as ImportType) ??
      ImportType.application,
    smartsuiteBackendUrl:
      process.env.REACT_APP_SS_BACKEND_URL ??
      localStorage.getItem("smartsuiteBackendUrl") ??
      "",
    memberId: localStorage.getItem("memberId") ?? DEFAULT_MEMBER.id,
    solutionId: localStorage.getItem("solutionId") ?? undefined,
  });

  const [isOpenAutomationUi, setIsOpenAutomationUi] = useState(true);

  const set = (settings: SetupSettings): void => {
    setValue(settings);
    localStorage.setItem("accountId", settings.accountId);
    localStorage.setItem("role", settings.role);
    localStorage.setItem("accessToken", settings.accessToken);
    localStorage.setItem("applicationId", settings.applicationId ?? "");
    localStorage.setItem("solutionId", settings.solutionId ?? "");
    localStorage.setItem("memberId", settings.memberId ?? "");
    localStorage.setItem("importType", settings.importType);
    localStorage.setItem("automationsUILang", settings.lang);
    localStorage.setItem("smartsuiteBackendUrl", settings.smartsuiteBackendUrl);
  };

  const solution = useMemo(
    () => buildDefaultSolution(value.solutionId),
    [value.solutionId],
  );

  const member = useMemo(
    () =>
      value.memberId
        ? { ...DEFAULT_MEMBER, id: value.memberId }
        : DEFAULT_MEMBER,
    [value.memberId],
  );

  return (
    <React.StrictMode>
      <SetupDropdown
        value={value}
        setValue={set}
        openAutomation={() => setIsOpenAutomationUi(true)}
      />
      {isOpenAutomationUi && (
        <ImportUI
          accountId={value.accountId}
          role={value.role}
          applicationId={value.applicationId}
          accessToken={value.accessToken}
          lang={value.lang}
          logoColor={value.logoColor}
          smartsuiteBackendUrl={value.smartsuiteBackendUrl}
          importType={value.importType}
          solution={solution}
          member={member}
        />
      )}
    </React.StrictMode>
  );
};
